import { Box } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { EditLine, SearchLine, Twinkle2Line } from "@dropbox/dig-icons/assets";
import { FiltersWithParametersAtom } from "@mirage/mosaics/Omnibox/atoms/filters";
import {
  getPrettyFilterName,
  getTypeaheadFilterDisplayProps,
} from "@mirage/mosaics/SearchBarWithTypeahead/typeahead-search-filter-result";
import { DashTruncateWithTooltip } from "@mirage/shared/util/DashTruncateWithTooltip";
import { useAtomValue } from "jotai";
import { useRef } from "react";
import { FilterChip } from "../FilterChip";
import { BaseResultRow } from "./BaseResultRow";

export const CurrentQueryResultRow = ({
  title,
  subtitle,
  iconType,
  currentQuery,
}: {
  isSelected: boolean;
  iconType: "search" | "edit" | "twinkle";
  title: string;
  subtitle: string;
  currentQuery?: string;
}) => {
  const filtersWithParameters = useAtomValue(FiltersWithParametersAtom);
  const ref = useRef<HTMLDivElement>(null);

  let icon;
  switch (iconType) {
    // Note: we need to manually override color to support inverted background in dark mode
    case "search":
      icon = <UIIcon src={SearchLine} color={"var(--dig-color__text__base)"} />;
      break;
    case "edit":
      icon = <UIIcon src={EditLine} color={"var(--dig-color__text__base)"} />;
      break;
    case "twinkle":
      icon = (
        <UIIcon src={Twinkle2Line} color={"var(--dig-color__text__base)"} />
      );
      break;
    default:
      icon = <UIIcon src={SearchLine} color={"var(--dig-color__text__base)"} />;
      break;
  }

  const renderFilters = () => {
    if (!filtersWithParameters?.length) return null;

    return (
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        columnGap="Micro XSmall"
        flexShrink={1}
        overflow="hidden"
      >
        {filtersWithParameters.map((filter, index) => {
          const { icon } = getTypeaheadFilterDisplayProps(
            currentQuery!,
            filter,
          );

          const prettyFilterName = getPrettyFilterName(filter);

          return (
            <FilterChip
              key={index}
              filterIcon={icon}
              title={prettyFilterName}
            />
          );
        })}
      </Box>
    );
  };

  return (
    <>
      <BaseResultRow
        icon={icon}
        richTitle={
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            columnGap="Micro Small"
          >
            {title.length ? (
              <Box flexShrink={0} style={{ maxWidth: "100%" }}>
                <DashTruncateWithTooltip tooltipProps={{ title }}>
                  {title}
                </DashTruncateWithTooltip>
              </Box>
            ) : null}

            {renderFilters()}
          </Box>
        }
        subtitle={subtitle}
        // Not using highlightWords to avoid unnecessary processing
        titleAlwaysBold
        ref={ref}
      />
    </>
  );
};
CurrentQueryResultRow.displayName = "CurrentQueryResultRow";
